import { graphql } from "@/gql";

export const generateCityDescriptionMutation = graphql(`
  mutation GenerateCityDescription($id: ID!) {
    generateCityDescription(id: $id) {
      id
      description
    }
  }
`);
